import React from 'react'
import PropTypes from 'prop-types'
import changeFileExtension from '@/lib/filename-extension-modifier'

import BrandLive from '@/component/Primitive/Brand/component/BrandLive'

const AboutLiveEventsWidget = ({ images, description }) => {
  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]

  const largeSrcSet = [
    {
      width: 720,
      src: changeFileExtension(
        getImage('desktop_background', '180x163', 720)?.url,
        'webp'
      )
    },
    {
      width: 1440,
      src: changeFileExtension(
        getImage('desktop_background', '180x163', 1440)?.url,
        'webp'
      )
    }
  ]
  const smallSrcSet = [
    {
      width: 320,
      src: changeFileExtension(
        getImage('mobile_background', '180x163', 320)?.url,
        'webp'
      )
    },
    {
      width: 640,
      src: changeFileExtension(
        getImage('mobile_background', '180x163', 640)?.url,
        'webp'
      )
    }
  ]

  const image = {
    desktop: {
      srcSet: largeSrcSet,
      alt: 'About Live Events Image',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('desktop_background', '1x1', 720)?.url
    },
    mobile: {
      srcSet: smallSrcSet,
      alt: 'About Live Events Image',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('mobile_background', '1x1', 320)?.url
    }
  }

  return <BrandLive image={image} description={description} />
}

AboutLiveEventsWidget.propTypes = {
  images: PropTypes.object,
  description: PropTypes.string
}

export default AboutLiveEventsWidget
